import type { VNode } from "preact";
import {SettingsButton} from "@/components/SettingsButton";
import {timeAgo} from "@/lib/time_utils";

type Props = {
  lastPoll: Date | null;
  refreshing: boolean;
  onPoll: () => void;
  onOpenSettings: () => void;
  preferred: string | null;
};
export function Header({lastPoll, refreshing, onPoll, onOpenSettings, preferred}: Props): VNode {
  return (
    <header class="header">
        <div class="header__inner">
            <a class="brand" href="/">
                <div class="brand__logo">N</div>
                <div class="brand__name">
                    Nitter
                    {/* On phones the wordy subtitle is replaced by the domain
                        name that actually matters here (the preferred
                        instance) — see the ≤640px rules in styles.css. */}
                    <small class="subtitle subtitle--app">Instance tracker</small>
                    {preferred && (
                        <small class="subtitle subtitle--domain">{preferred}</small>
                    )}
                </div>
            </a>
            <div class="header__actions">
                {preferred && (
                    <span
                        class="pref-chip"
                        data-tip="Your preferred instance — saved in this browser's local storage. /view links will open through it while it stays healthy. Change it in Settings or with the ★ button on any row."
                        data-tipkey="header-preferred"
                    >
              <svg width="11" height="11" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1"
                   stroke-linejoin="round">
                <path d="m12 2 3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
              </svg>
                        {preferred}
            </span>
                )}
                <a class="btn btn--ghost btn--sm" href="/data-source">
                    Data source
                </a>
                <span class="last-poll">Updated {timeAgo(lastPoll)}</span>

                <SettingsButton onClick={onOpenSettings}/>

                <button data-tip="Fetch the uptime feed and recompute every score." data-tipkey="header-poll" className="btn btn--primary btn--sm" onClick={onPoll} disabled={refreshing}>
                    <svg class={refreshing ? "spin" : ""} width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8"/>
                        <path d="M21 3v5h-5"/>
                    </svg>
                    {refreshing ? "Polling…" : "Poll now"}
                </button>
            </div>
        </div>
    </header>
  );
}
